import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import {
  type TokenQuery,
  type SpecialResponse,
} from "shared/api/types/society/[societyId]/token/[tokenValue]";
export const getSocietyTokenValueContract: BaseApiContract<
  TokenQuery,
  undefined,
  SpecialResponse
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/token/[tokenValue]",
  paramsType: {} as TokenQuery,
  responseType: {} as SpecialResponse,
};
